import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-24 bg-background-950">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-2">
              APP下载
            </h2>
            <div className="w-12 h-1 bg-primary-500 rounded-full mb-6 lg:mx-0 mx-auto"></div>
            <p className="text-lg md:text-xl font-heading text-primary-400 mb-4">
              {appData.title}
            </p>
            <p className="text-sm md:text-base text-foreground-300 leading-relaxed max-w-md lg:mx-0 mx-auto mb-6">
              {appData.desc}
            </p>

            <div className="flex flex-wrap gap-2 justify-center lg:justify-start mb-8">
              {appData.features.map((f) => (
                <span
                  key={f}
                  className="px-3 py-1.5 rounded-full bg-background-800 text-foreground-300 text-xs whitespace-nowrap"
                >
                  {f}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-all duration-200 text-center whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-android-line mr-2"></i>
                Android 下载
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold bg-background-700 text-background-50 rounded-lg hover:bg-background-600 transition-all duration-200 text-center whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-apple-line mr-2"></i>
                iOS 下载
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-xs lg:max-w-sm flex justify-center">
            <div className="w-56 h-56 md:w-64 md:h-64 rounded-3xl bg-background-800 flex items-center justify-center border border-background-700">
              <div className="text-center">
                <i className="ri-smartphone-line text-6xl text-foreground-400"></i>
                <p className="text-foreground-400 text-sm mt-4">扫码下载App</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}